import { Coin } from '@cakedefi/cake-sdk';

const CategoryMap: Record<string, string> = {
  CRYPTOCURRENCY: 'Cryptocurrency',
};

export function getCoinCategoryName(coin: Coin) {
  return CategoryMap[coin.category] || 'Decentralized Asset';
}
